<template>
  <router-link
    v-if="depth !== 0"
    class="tile is-child notification"
    :class="color"
    :to="route(value.id)">

    <p class="title is-size-6">{{ value.parsed }}</p>
  </router-link>

  <article
    v-else-if="depth === 0"
    class="tile is-child notification"
    :class="color">
    <p class="title is-5">{{ value.parsed }}</p>

    <hr>

    <ul v-show="value.children.children.length > 0">
      <router-link
        tag="li"
        v-for="child in value.children.children"
        :key="child.id"
        :to="route([value.id, child.id])">

        {{ child.parsed }}
      </router-link>
    </ul>
  </article>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PageGridItem',
  props: {
    parents: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      page: 'pages/page',
      isPublic: 'pages/isPublic'
    })
  },
  methods: {
    route (ids) {
      return {
        name: (!this.isPublic) ? 'page' : 'public-page',
        params: {
          code: this.$route.params.code,
          path: (Array.isArray(ids)) ? ids.join(',') : `${this.$route.params.path},${ids}`
        }
      }
    }
  }
}
</script>
